import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (!localStorage.getItem("cookie_consent")) setVisible(true);
    }, []);
    if (!visible) return null;
    const decide = (value) => {
        localStorage.setItem("cookie_consent", value);
        setVisible(false);
    };
    return (
        <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 bg-white border border-[hsl(var(--border))] rounded-3xl shadow-2xl p-6" data-testid="cookie-banner">
            <h4 className="font-display font-bold text-stone-900 mb-1">Utilizamos cookies</h4>
            <p className="text-sm text-stone-600 leading-relaxed mb-4">
                Este website usa apenas cookies essenciais ao seu funcionamento. Poderemos ativar cookies analíticos com o seu consentimento. <Link to="/cookies" className="text-[hsl(var(--moss))] underline underline-offset-2">Saber mais</Link>.
            </p>
            <div className="flex gap-2">
                <button data-testid="cookie-reject" onClick={() => decide("essential")} className="flex-1 py-2.5 text-sm border border-[hsl(var(--border))] rounded-full hover:bg-[hsl(var(--stone-card))] text-stone-700 transition">
                    Apenas essenciais
                </button>
                <button data-testid="cookie-accept" onClick={() => decide("all")} className="flex-1 py-2.5 text-sm bg-[hsl(var(--moss))] hover:brightness-95 rounded-full font-medium text-white transition">
                    Aceitar todos
                </button>
            </div>
        </div>
    );
}
